
import { Vue, Component, Prop } from 'vue-property-decorator'
import gql from 'graphql-tag'
import _debounce from 'lodash/debounce'

@Component({
  apollo: {
    $subscribe: {
      collectionDataChanged: {
        query: gql`
          subscription collectionDataChanged(
            $environmentId: ID
            $collectionId: ID
          ) {
            collectionDataChanged(
              environmentId: $environmentId
              collectionId: $collectionId
            )
          }
        `,
        variables() {
          return {
            environmentId:
              this.environmentId || this.collectionId.split('_')[0],
            collectionId: this.collectionId
          }
        },
        result({ data }: any) {
          if (this.enabled) {
            this.emitUpdate()
          } else {
            this.updatePending = true
          }
        }
      }
    }
  }
})
export default class CollectionWatcher extends Vue {
  @Prop({ type: String }) environmentId?: string
  @Prop({ type: String, required: true }) collectionId!: string

  enabled = !document.hidden
  updatePending = false

  render() {
    return null
  }

  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  }

  beforeDestroy() {
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    )
  }

  handleVisibilityChange() {
    this.enabled = !document.hidden
    if (this.enabled && this.updatePending) {
      this.emitUpdate()
      this.updatePending = false
    }
  }

  emitUpdate() {
    this.$emit('update')
  }
}
